<template>
  <nav class="nav">
    <div class="nav-l">
      <slot name="left"/>
    </div>
    <div class="nav-r">
      <slot name="right" class="right"/>
    </div>
  </nav>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.nav {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
  .nav-l {
    .input-text {
      margin-right: 10px;
      width: 275px;
    }
    .input-select {
      margin-right: 10px;
      width: 100px;
    }
    .input-date {
      margin-right: 10px;
      width: 275px;
    }
    div {
      height: 100%;
      display: flex;
      align-items: center;
      button {
        margin-left: 5px;
      }
    }

    // span{
    //   font-weight: bold;
    //   margin-right: 30px;
    //   cursor: pointer;
    // }
  }
}
</style>
